import React, { useState, useEffect } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";

export default function CustomFaqAccordion({ children, isActive, extraClassName, onEdit, onDelete }) {
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        if (isActive) {
            setActiveIndex(0);
        } else {
            setActiveIndex(null);
        }
    }, [isActive]);

    const headerTemplate = (child) => {
        const handleEditClick = (e) => {
            e.preventDefault(); // Prevent default navigation
            e.stopPropagation(); // Prevent the accordion from toggling
            onEdit(child);
        };

        const handleDeleteClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            onDelete(e, child._id);
        };

        return (
            <div className="flex justify-content-between w-full">
                <span className="font-bold white-space-nowrap">{child.question}</span>
                <div className="flex justify-content-around gap-2">
                    <i className="pi pi-pencil cursor-pointer" onClick={handleEditClick}></i>
                    <i className="pi pi-trash cursor-pointer" onClick={handleDeleteClick}></i>
                </div>
            </div>
        );
    };

    return (
        <Accordion
            onTabChange={(e) => setActiveIndex(e.index)}
            activeIndex={activeIndex}
            className={`custom-accordion border-none my-2 ${extraClassName}`}
        >
            {children?.map((child, index) => (
                <AccordionTab key={index} headerTemplate={() => headerTemplate(child)} className={extraClassName}>
                    {child.answer}
                </AccordionTab>
            ))}
        </Accordion>
    );
}
